import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { DeliveryChallanSchema } from "../../../Schemas/purchase/delivery_challan.schema";
import { getId, toTitleCase } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import {
  DeliveryChallanInfo,
  DeliveryLineItemInfo,
} from "../../../SchemaInfo/info";

const EditDeliveyChallan = () => {
  let { id } = useParams();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [deliveryChallanInfo, setDeliveryChallanInfo] =
    useState(DeliveryChallanInfo);
  const [projects, setProjects] = useState([]);
  const [listNum, setListNum] = useState([]);
  const [listId, setListId] = useState(null);
  const [materialData, setMaterialData] = useState([]);
  const [hydrponicType, setHydrponicType] = useState();
  const [currentInventoryData, setCurrentInventoryData] = useState([]);
  const [pendingDcData, setPendingDcData] = useState([]);
  const [totalCount, setTotalCount] = useState([]);

  const [data, setData] = useState([]);
  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.MaterialList);
          setTotalCount(res?.data?.consolidatedList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });

    values = {
      ...values,
      cusClientName: toTitleCase(values.cusClientName),
      driverName: toTitleCase(values.driverName),
      transportName: toTitleCase(values.transportName),
    };
    let { lineItems, ...rest } = values;

    const formData = new FormData();
    for (let key in rest) {
      if (key === "additionalPhotos") {
        values.additionalPhotos.forEach((file, index) => {
          formData.append(`additionalPhotos-${index}`, file);
        });
      } else {
        formData.append(key, values[key]);
      }
    }
    const lineItemsMetadata = lineItems.map(({ uploadPhoto, ...rest }) => {
      return {
        ...rest,
        ...(typeof uploadPhoto === "string" && uploadPhoto !== ""
          ? { uploadPhoto }
          : {}),
      };
    });

    formData.append("lineItems", JSON.stringify(lineItemsMetadata));

    // // Append new photo files separately, key them as uploadPhoto-0, uploadEcPhoto-0 etc.
    lineItems.forEach((item, index) => {
      if (item.uploadPhoto instanceof File) {
        formData.append(`uploadPhoto-${index}`, item.uploadPhoto);
      }
    });

    // setLoading(true);
    performRequest("PATCH", `/deliveryChallan/updateDc/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "DC Updated successfully!");
          navigate(`/delivery-challan/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/deliveryChallan/getDcById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setDeliveryChallanInfo(res.data?.dcStatus);
          setMaterialData(res?.data?.materialData?.materialList);
          setListId(res?.data?.materialData?.id);
          setHydrponicType(res?.data?.materialData?.hydroponicType);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/get-all-hm-lists")
      .then((res) => {
        if (res.status === 201) {
          setListNum(res.data?.allMaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const checkTouched = (obj) => {
    if (
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (deliveryChallanInfo?.isApproved) {
      Toast("error", "This DC is already approved! can't edit.");
      navigate(`/delivery-challan/view/${id}`);
    }
  }, [deliveryChallanInfo]);

  const handleListNumChange = async (e, props) => {
    const selectedNum = e.target.value;

    // Update Formik value
    props.setFieldValue("materilListNum", selectedNum);

    if (!selectedNum) {
      setMaterialData([]);
      return;
    }
    performRequest(
      "GET",
      `/materialPlanning/getMaterialByListNum/${selectedNum}`
    )
      .then((res) => {
        if (res.status === 200) {
          setMaterialData(res.data?.materialList);
          setHydrponicType(res.data?.hydroponicType);
        } else {
          Toast("error", "Error while getting Lead!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);

    // if weight is a valid number > 0 and unit is among the specified ones, calculate with weight
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }

    // fallback if weight is missing or 0
    return costperUnit * inStock;
  };

  const handelInputChange = (e, index) => {
    let updatedData = materialData.map((item, idx) => {
      if (item?.id === index) {
        return { ...item, attachPhoto: e.target.files[0] };
      } else {
        return item;
      }
    });
    setMaterialData(updatedData);
  };
  const handelUploadListPhotos = (material) => {
    const formData = new FormData();

    const validFiles = material?.filter(
      (item) => item && item.attachPhoto instanceof File
    );

    if (!validFiles || validFiles.length === 0) {
      return Toast("error", "No new photos to upload!");
    }

    if (!listId) {
      return Toast("error", "Material List ID is missing!");
    }

    validFiles.forEach((file) => {
      formData.append(`attachPhoto-${file.id}`, file.attachPhoto);
    });

    performRequest(
      "PATCH",
      `/deliveryChallan/updateMaterialLoadingPhoto/${listId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Photos Updated successfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/getAllMaterialList`)
      .then((res) => {
        if (res.status === 200) {
          setCurrentInventoryData(res?.data?.MaterialList);
          setPendingDcData(res?.data?.consolidatedList);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleQuantityChange = (e, index, props) => {
    const { setFieldValue } = props;

    const sku = props.values.lineItems[index]?.sku;
    let itemFrom = props.values.lineItems[index]?.itemFrom;

    const value = e.target.value;

    if (itemFrom === "custom") {
      setFieldValue(`lineItems[${index}].itemQuantity`, value);
      return;
    }

    if (!/^\d*$/.test(value)) return;

    // ✅ FIRST: set value so user sees full number
    setFieldValue(`lineItems[${index}].itemQuantity`, value);

    let enteredQty = Number(value || 0);
    let stock =
      currentInventoryData.find((inv) => inv.sku === sku)?.inStock || 0;

    if (pendingDcData) {
      let pendingCount =
        pendingDcData.find((inv) => inv.sku === sku)?.totalRequired || 0;
      enteredQty = enteredQty + pendingCount;
    }

    if (enteredQty > stock) {
      setTimeout(() => {
        const confirmResult = window.confirm(
          `Please update stock first. Short by ${enteredQty - stock}`
        );
        // 🔁 If user clicks OK or Cancel → reset field
        if (confirmResult === true || confirmResult === false) {
          setFieldValue(`lineItems[${index}].itemQuantity`, "");
        }
      }, 0);
    } else {
      setFieldValue(`lineItems[${index}].itemQuantity`, value);
    }
  };

  const totalCountArray = Array.isArray(totalCount)
    ? totalCount
    : Object.values(totalCount);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Delivery Challan</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Delivery Challan</h2>
            </div>
            <Formik
              initialValues={deliveryChallanInfo}
              validationSchema={DeliveryChallanSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">Project</label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="project">
                          <option value="">Select</option>
                          {projects &&
                            projects?.map((pro) => {
                              return (
                                <option
                                  key={pro.cpNumber}
                                  value={getId(pro.cpNumber)}
                                >
                                  {pro.clientName}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.project && props.errors.project && (
                          <p className="text-danger">{props.errors.project}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Custom Client Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="cusClientName" />

                        {props.touched.cusClientName &&
                          props.errors.cusClientName && (
                            <p className="text-danger">
                              {props.errors.cusClientName}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Material List Number
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          type="text"
                          name="materilListNum"
                          onChange={(e) => handleListNumChange(e, props)}
                        >
                          <option value="">Select</option>
                          {listNum &&
                            listNum?.map((pro) => {
                              return (
                                <option
                                  key={pro?.uniqueNum}
                                  value={pro?.uniqueNum}
                                >
                                  {pro?.uniqueNum}
                                </option>
                              );
                            })}
                        </CustomSelect>

                        {props.touched.materilListNum &&
                          props.errors.materilListNum && (
                            <p className="text-danger">
                              {props.errors.materilListNum}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Country of supply
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="countryOfSupply">
                          <option value="">Select Country</option>
                          <option value="india">India</option>
                        </CustomSelect>

                        {props.touched.countryOfSupply &&
                          props.errors.countryOfSupply && (
                            <p className="text-danger">
                              {props.errors.countryOfSupply}
                            </p>
                          )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Place of supply
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="placeOfSupply" />

                        {props.touched.placeOfSupply &&
                          props.errors.placeOfSupply && (
                            <p className="text-danger">
                              {props.errors.placeOfSupply}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Challan date
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="date" name="challanDate" />

                        {props.touched.challanDate &&
                          props.errors.challanDate && (
                            <p className="text-danger">
                              {props.errors.challanDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Lr number</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="lrNumber" />

                        {props.touched.lrNumber && props.errors.lrNumber && (
                          <p className="text-danger">{props.errors.lrNumber}</p>
                        )}
                      </div>
                    </div>
                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Eway bill number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="ewayBillNumber" />

                        {props.touched.ewayBillNumber &&
                          props.errors.ewayBillNumber && (
                            <p className="text-danger">
                              {props.errors.ewayBillNumber}
                            </p>
                          )}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Transport name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="transportName" />

                        {props.touched.transportName &&
                          props.errors.transportName && (
                            <p className="text-danger">
                              {props.errors.transportName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vehicle number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="vehicleNumber" />

                        {props.touched.vehicleNumber &&
                          props.errors.vehicleNumber && (
                            <p className="text-danger">
                              {props.errors.vehicleNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Driver name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="driverName" />

                        {props.touched.driverName &&
                          props.errors.driverName && (
                            <p className="text-danger">
                              {props.errors.driverName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Driver phone number
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="driverPhoneNumber" />

                        {props.touched.driverPhoneNumber &&
                          props.errors.driverPhoneNumber && (
                            <p className="text-danger">
                              {props.errors.driverPhoneNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Driver's DL
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="driverDL"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("driverDL", e.target.files[0])
                          }
                        />
                        {props.touched.driverDL && props.errors.driverDL && (
                          <p className="text-danger">{props.errors.driverDL}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vehicle Front
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="vehicleFront"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "vehicleFront",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.vehicleFront &&
                          props.errors.vehicleFront && (
                            <p className="text-danger">
                              {props.errors.vehicleFront}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Vehicle Back
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="vehicleBack"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "vehicleBack",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.vehicleBack &&
                          props.errors.vehicleBack && (
                            <p className="text-danger">
                              {props.errors.vehicleBack}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Additional photos
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="additionalPhotos"
                          type="file"
                          multiple
                          onChange={(e) =>
                            props.setFieldValue(
                              "additionalPhotos",
                              Array.from(e.target.files)
                            )
                          }
                        />
                        <p>You can select multiple photos for this feild</p>
                        {props.touched.additionalPhotos &&
                          props.errors.additionalPhotos && (
                            <p className="text-danger">
                              {props.errors.additionalPhotos}
                            </p>
                          )}
                      </div>
                    </div>
                    {props.values?.materilListNum && (
                      <hr className="m-0 p-0"></hr>
                    )}
                    {props.values?.materilListNum && (
                      <h2 className="mt-2">Material List : </h2>
                    )}
                    {props.values?.materilListNum && <hr></hr>}
                    {props.values?.materilListNum && (
                      <div className="col-lg-12 col-md-12">
                        <div className="table-responsive">
                          <table className="table table-vcenter w-100 border">
                            <thead>
                              <tr>
                                <th style={{ minWidth: "150px" }}>
                                  Sr/ HSN/ Image
                                </th>
                                <th style={{ minWidth: "170px" }}>
                                  ITEM /SKU/ Weight/ Formula
                                </th>
                                <th style={{ minWidth: "200px" }}>
                                  Specifications
                                </th>
                                <th>In stock / Count / Price</th>
                                <th>Loading time Photo</th>
                              </tr>
                            </thead>

                            <tbody>
                              {materialData
                                ?.filter((item) => item?.count)
                                .map((item, index) => {
                                  const specialSkus = [
                                    "MAT-CEA-FLA-FOG-GRO-00042",
                                  ];

                                  const totalCount = specialSkus.includes(
                                    item?.sku
                                  )
                                    ? item?.countGrow || 0
                                    : (item?.countFlat || 0) +
                                      (item?.countGrow || 0);

                                  return (
                                    <tr
                                      key={index}
                                      // style={{
                                      //   backgroundColor:
                                      //     Number(item.count) >
                                      //     Number(
                                      //       currentInventoryData.find(
                                      //         (inv) => inv.sku === item.sku
                                      //       )?.inStock || 0
                                      //     )
                                      //       ? "#ffcccc"
                                      //       : "transparent",
                                      // }}

                                      style={{
                                        backgroundColor: (() => {
                                          const inventoryStock = Number(
                                            currentInventoryData.find(
                                              (inv) => inv.sku === item.sku
                                            )?.inStock || 0
                                          );

                                          // Special case: Growbag SKU + hydrophonicsOly type
                                          if (
                                            item.sku ===
                                              "MAT-CEA-FLA-FOG-GRO-00042" &&
                                            hydrponicType === "hydroponicsOnly"
                                          ) {
                                            return Number(item.countGrow) >
                                              inventoryStock
                                              ? "#ffcccc"
                                              : "transparent";
                                          }

                                          // Default behavior
                                          return Number(item.count) >
                                            inventoryStock
                                            ? "#ffcccc"
                                            : "transparent";
                                        })(),
                                      }}
                                    >
                                      {/* Column 1 */}
                                      <td>
                                        <img
                                          src={item?.image}
                                          alt={item?.item}
                                          width="150"
                                          height="150"
                                          className="m-0 mt-1 mb-1"
                                          style={{ borderRadius: "8px" }}
                                        />
                                        <br />
                                        <span className="me-1">
                                          {index + 1}.
                                        </span>
                                        {item?.hsn && (
                                          <span className="fs-5">
                                            <b>HSN: {item?.hsn}</b>
                                          </span>
                                        )}
                                      </td>

                                      {/* Column 2 */}
                                      <td>
                                        <span className="fs-5">
                                          {item?.item}
                                        </span>
                                        <br />
                                        <b>SKU : {item?.sku}</b>

                                        {item?.weight && (
                                          <>
                                            <br />
                                            <b>
                                              Weight : {item?.weight}{" "}
                                              {item?.proUnit}
                                            </b>
                                          </>
                                        )}

                                        {item?.formula && (
                                          <>
                                            <br />
                                            <b>Formula : {item?.formula}</b>
                                          </>
                                        )}

                                        {item?.flatFormul && (
                                          <>
                                            <br />
                                            <b>Formula : {item?.flatFormul}</b>
                                          </>
                                        )}

                                        {item?.mergeType && (
                                          <>
                                            <br />
                                            <b>
                                              Available in : {item?.mergeType}
                                            </b>
                                          </>
                                        )}

                                        {(item?.countFlat ||
                                          item?.countGrow) && (
                                          <>
                                            <br />
                                            <b>
                                              Flatbed Count :{" "}
                                              {item?.countFlat || "0"}
                                              {item?.unit}
                                            </b>
                                            <br />
                                            <b>
                                              Growbags Count :{" "}
                                              {item?.countGrow || "0"}
                                              {item?.unit}
                                            </b>
                                            <hr className="p-0 m-1" />
                                            <b>
                                              Total Count : {totalCount}
                                              {item?.unit}
                                            </b>
                                          </>
                                        )}
                                      </td>

                                      {/* Column 3 */}
                                      <td className="fs-5">
                                        {item?.specificationsNew?.length
                                          ? [
                                              ...new Map(
                                                item.specificationsNew
                                                  .filter(
                                                    (spec) =>
                                                      (hydrponicType ===
                                                        "cea-nvph" &&
                                                        spec?.type === "cea") ||
                                                      hydrponicType ===
                                                        spec?.type ||
                                                      (hydrponicType ===
                                                        "hydroponicsOnly" &&
                                                        (spec?.type ===
                                                          "flatbed" ||
                                                          spec?.type ===
                                                            "growbags"))
                                                  )
                                                  .map((spec) => [
                                                    spec?.specification,
                                                    spec,
                                                  ])
                                              ).values(),
                                            ].map((spec, i) => (
                                              <div key={i}>
                                                {spec?.specification}
                                              </div>
                                            ))
                                          : "N/A"}
                                        <br className="m-0 p-0"></br>
                                        {item?.brandName && (
                                          <p className="m-0 badge bg-green-lt">
                                            Brand Name: {item?.brandName}
                                          </p>
                                        )}

                                        {totalCountArray?.length > 0 && (
                                          <>
                                            <hr className="mb-1 mt-0 p-0"></hr>
                                            <h4 className="m-0 fw-bold">
                                              Total Stock For DC Approval :
                                            </h4>
                                            <div>
                                              <span className="fs-2">
                                                <b>
                                                  {totalCountArray.find(
                                                    (inv) =>
                                                      inv.sku === item.sku
                                                  )?.totalRequired ?? 0}
                                                  {totalCountArray.find(
                                                    (inv) =>
                                                      inv.sku === item.sku
                                                  )
                                                    ? item?.unit
                                                    : ""}
                                                </b>
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </td>

                                      {/* Column 4 */}
                                      <td style={{ width: "120px" }}>
                                        <span className="fs-3">
                                          <b>
                                            Count :{" "}
                                            {[
                                              "MAT-CEA-FLA-FOG-GRO-00042",
                                            ].includes(item?.sku) &&
                                            hydrponicType === "hydroponicsOnly"
                                              ? item?.countGrow || 0
                                              : item?.count || 0}
                                            {item?.unit || "N/A"}
                                            <span>
                                              {item?.countKg
                                                ? ` / ${item?.countKg}kg`
                                                : ""}
                                            </span>
                                          </b>
                                        </span>
                                        <hr className="m-1" />
                                        <b>
                                          In Stock :{" "}
                                          {Number(
                                            currentInventoryData.find(
                                              (inv) => inv.sku === item.sku
                                            )?.inStock || 0
                                          )}
                                        </b>
                                        <hr className="m-1" />
                                        <b>
                                          Cost/Unit : {roundOffCost(item?.cost)}
                                        </b>
                                        <hr className="m-1" />
                                        <b>
                                          Total :
                                          {roundOffCost(
                                            getPrice(
                                              item?.count,
                                              item?.cost,
                                              item?.weight,
                                              item?.proUnit
                                            )
                                          )}
                                        </b>
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          name={`materialData[${index}].attachPhoto`}
                                          type="file"
                                          onChange={(e) =>
                                            handelInputChange(e, item?.id)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}

                              {/* ✅ Fixed Total Row */}
                              <tr>
                                <td
                                  colSpan="3"
                                  className="text-end fw-bold fs-4"
                                >
                                  Total Cost:
                                </td>
                                <td className="fw-bold fs-4">
                                  {roundOffCost(
                                    materialData?.reduce(
                                      (acc, item) =>
                                        acc +
                                        (getPrice(
                                          item?.count,
                                          item?.cost,
                                          item?.weight,
                                          item?.proUnit
                                        ) || 0),
                                      0
                                    )
                                  )}
                                </td>
                                <td className="fw-bold fs-4">
                                  <button
                                    className="btn btn-primary "
                                    type="button"
                                    onClick={() => {
                                      handelUploadListPhotos(materialData);
                                    }}
                                  >
                                    Upload Lists Photos
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props?.values?.lineItems?.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = data?.find(
                                            (el) => el.id == e.target.value
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].sku`,
                                            item?.sku
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {data?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}

                                {/* {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">HSN:</label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].hsn`}
                                      />
                                    </div>
                                  </div>
                                )} */}
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                      onChange={(e) =>
                                        handleQuantityChange(e, index, props)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className="form-label">
                                    Loading time photo
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      name={`lineItems[${index}].uploadPhoto`}
                                      type="file"
                                      onChange={(e) =>
                                        props.setFieldValue(
                                          `lineItems[${index}].uploadPhoto`,
                                          e.target.files[0]
                                        )
                                      }
                                    />
                                    {props.touched.lineItems?.[index]
                                      ?.uploadPhoto &&
                                      props.errors.lineItems?.[index]
                                        ?.uploadPhoto && (
                                        <p className="text-danger">
                                          {
                                            props.errors.lineItems[index]
                                              .uploadPhoto
                                          }
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary mt-4"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>

                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push(DeliveryLineItemInfo);
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push(DeliveryLineItemInfo);
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...DeliveryLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...DeliveryLineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save Delivery Challan" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditDeliveyChallan;
